module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "secMenu"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'caseinfo'
      }
    }
  }, [_c('div', [_vm._v("基本资料")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'caseDiag'
      }
    }
  }, [_c('div', [_vm._v("病症诊断")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'evalRecord'
      }
    }
  }, [_c('div', [_vm._v("测评记录")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'trainPlan'
      }
    }
  }, [_c('div', [_vm._v("训练方案")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'trainRecord'
      }
    }
  }, [_c('div', [_vm._v("训练记录")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'brainStatus'
      }
    }
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._v("脑能力状态\n    "), _c('sup', {
    staticStyle: {
      "color": "#fff",
      "border-radius": "2px",
      "width": "40px",
      "height": "14px",
      "line-height": "14px",
      "font-size": "10px",
      "background-color": "#e75710",
      "position": "absolute",
      "top": "12px",
      "right": "23px"
    }
  }, [_vm._v("测试版")])])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'collectInfo'
      }
    }
  }, [_c('div', [_vm._v("信息采集")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'caseOrder',
        query: {
          status: 1
        }
      }
    }
  }, [_c('div', [_vm._v("居家康复")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69e2ceaf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/case/secondmenu.vue
// module id = 1002
// module chunks = 2